import * as types from 'customers/actions/types'

const initialState = {
  customerList: [],
  isLoading: true,
  totalCount: 0,
  pageCount: 0,
  currentPage: 1,
  showActive: true,
  current: [],
  active: [],
  inactive: [],
  customer: null,
  attachments: [],
  searchText: '',
  showHours: false
}

export default function customers (state = initialState, action) {
  switch (action.type) {
    case types.SORT_PAGE:
      return {
        ...state,
        customerList: action.customerList
      }
    case types.FETCH_CUSTOMER_LIST:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCH_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        customerList: action.customerList,
        customerCount: action.totalCount,
        pageCount: action.pageCount,
        sizePerPage: action.sizePerPage,
        totalCount: action.totalCount,
        currentPage: action.currentPage,
        isLoading: false,
      }
    case types.FETCH_CUSTOMER:
      return { ...state, customer: action.customer }
    case types.FETCH_ATTACHMENT_LIST:
      return { ...state, attachments: action.attachments }
    case types.SET_SEARCH_TEXT:
      return {
        ...state, searchText: action.searchText, currentPage: 1
      }
    case types.CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.currentPage,
        sizePerPage: action.sizePerPage,
        isLoaded: false,
        invoiceListIsLoading: true
      }
    case types.UPDATE_CUSTOMER:
      return {
        ...state,
        customer: action.customer
      }
      case types.LOCATION_UPDATE:
      return {
        ...state,
        customer: action.customer
      }
    case types.ADD_CONTACT:
      return {
        ...state,
        customer: action.customer
      }
    case types.DELETE_CONTACT:
      return {
        ...state,
        customer: action.customer
      }
    case types.NOTE_CREATE:
      return {
        ...state,
        customer: action.customer
      }
    case types.DELETE_NOTE:
      return {
        ...state,
        customer: action.customer
      }
    case types.ADD_WORK:
      return {
        ...state,
        customer: action.customer
      }
    case types.DELETE_TIME_SHEET:
    case types.ADD_TIME_SHEET:
      return {
        ...state,
        customer: action.customer
      }
    case types.TOGGLE_ACTIVE:
      return {
        ...state,
        showActive: action.showActive
      }
    case types.TOGGLE_HOURS:
      return {
        ...state,
        showHours: action.showHours
      }
    default:
      return state
  }
}
